import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { Maintenance } from '@core/interfaces';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import moment from 'moment';
import { sentry } from 'sentry';

@Component({
  selector: 'app-dialog-reopen-maintenance',
  templateUrl: './dialog-reopen-maintenance.component.html',
  styleUrls: ['./dialog-reopen-maintenance.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogReopenMaintenanceComponent implements OnInit, OnDestroy {

  public reopenMaintenancesForm: FormGroup;
  public isReopenMaintenance: boolean;
  public refreshDatatable = false;
  public maintenance: Maintenance;
  public isViewMode: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<DialogReopenMaintenanceComponent>,
    private fuseProgressBarService: FuseProgressBarService,
    private customMessageService: CustomMessagesService,
    private maintenancesApi: MaintenancesApi,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.maintenance = this.data.maintenance;
    this.isViewMode = this.data.isViewMode;

    this.reopenMaintenancesForm = this.formBuilder.group({
      id: this.maintenance.id ? this.maintenance.id : null,
      status: this.maintenance.status ? this.maintenance.status : null,
      number: new FormControl({ value: this.maintenance.number, disabled: true }, [Validators.required]),
      type: new FormControl({ value: this.maintenance.maintenanceType && this.maintenance.maintenanceType.name, disabled: true }, [Validators.required]),
      openedDate: new FormControl({ value: moment(this.maintenance.openedAt).toDate(), disabled: true }, [Validators.required]),
      openedTime: new FormControl({ value: moment(this.maintenance.openedAt).format('HH:mm'), disabled: true }, [Validators.required]),
      segment: new FormControl({ value: this.maintenance.segment, disabled: true }, [Validators.required]),
      scheduleSuggestions: this.maintenance.scheduleSuggestions && this.maintenance.scheduleSuggestions.length > 0 ? new FormArray(
        this.maintenance.scheduleSuggestions.map((scheduleSuggestion) => new FormControl(scheduleSuggestion))
      ) : new FormArray([]),
      scheduleSuggestionsStatus: this.maintenance.scheduleSuggestionsStatus ? this.maintenance.scheduleSuggestionsStatus : null,
      reopenReason: new FormControl(null, [Validators.required])
    });
  }

  ngOnDestroy(): void {
    this.matDialogRef.close(this.refreshDatatable);
  }

  async reopenMaintenance(): Promise<void> {
    this.fuseProgressBarService.show();
    this.isReopenMaintenance = true;

    await this.maintenancesApi.reopenMaintenance({
      id: this.maintenance.id,
      reopeningReason: this.reopenMaintenancesForm.get('reopenReason').value,
      scheduleSuggestions: this.reopenMaintenancesForm.get('scheduleSuggestions').value.map((scheduleSuggestion) => {
        const date = moment.utc(scheduleSuggestion.date).format('YYYY-MM-DD');
        return { date, time: scheduleSuggestion.time };
      })
    }).then(() => {
      this.customMessageService.success('MAINTENANCES.REOPEN_MAINTENANCE_DIALOG.SAVE_SUCCESS');
    }).catch((err) => {
      sentry.captureException(err);
      this.customMessageService.error('MAINTENANCES.REOPEN_MAINTENANCE_DIALOG.SAVE_FAILED');
    }).finally(() => {
      this.fuseProgressBarService.hide();
      this.refreshDatatable = true;
      this.isReopenMaintenance = false;
      this.matDialogRef.close(true);
    });
  }
}
